<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron @click="$router.back()"/>
                {{ $t('health.nutritionalPlanTemplate.title') }}
              </h1>
              <div class="header-add-button">
                <span
                  v-tooltip.left.top-start="$t('health.nutritionalPlanTemplate.create')"
                  @click="createTemplate">
                  <font-awesome-icon
                    class="header-add-button-icon"
                    :icon="icon.add"/>
                </span>
              </div>
            </div>
          </grid-col>
        </grid-row>

        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="templateTable"
              :data="fetchData"
              sort-by="name"
              sort-order="asc"
              :show-caption="false"
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <table-column
                show="id"
                :hidden="true"
                :filterable="false"/>
              <table-column
                show="name"
                :label="$t('health.patient.name')"
                header-class="text-left"
                cell-class="table-component__text-left"/>
              <table-column
                show="description"
                :label="$t('health.nutritionalPlanTemplate.description')"
                header-class="text-left"
                cell-class="table-component__text-left"/>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-on:click="editTemplate(row)"
                    :icon="icon.edit"
                    class="table-iconset-icon"/>
                </template>
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-on:click="removeTemplate(row)"
                    :icon="icon.remove"
                    class="table-iconset-icon"/>
                </template>
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>
      </div>

      <ok-cancel-modal
        v-if="showConfirmationDeleteModal"
        v-on:ok="onDeleteConfirm"
        v-on:cancel="onDeleteCancel"
        :title="$t('health.nutritionalPlanTemplate.delete')"
        :message="$t('health.nutritionalPlanTemplate.delete')"
        :okButton="$t('commons.delete')"
        :cancelButton="$t('commons.cancel')">
        <div slot="body">
          <ul>
            <li>{{ templateToDelete && templateToDelete.name }}</li>
          </ul>
        </div>
      </ok-cancel-modal>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
import Chevron from '@/components/shared/Chevron';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { mapGetters } from 'vuex';
import templateApi from '../../api/template';

export default {
  name: 'NutritionalPlanTemplateList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    FontAwesomeIcon,
    Chevron,
    OkCancelModal,
  },
  data () {
    return {
      templates: [],
      breadcrumb: [
        { link: '/workspace', name: this.$t('menu.workspace') },
        { link: '/nutritional-plan-template', name: this.$t('health.nutritionalPlanTemplate.title'), disabled: true }
      ],
      icon: {
        add: faPlusCircle,
        remove: faTrashAlt,
        edit: faPencilAlt
      },
      showConfirmationDeleteModal: false,
      templateToDelete: null,
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: { order: '', fieldName: '' }
      }
    };
  },
  mounted () {
    this.requestTemplates();
  },
  computed: {
    ...mapGetters(['getLanguageCode']),
    getBreadcrumb () {
      return this.breadcrumb;
    },

  },
  methods: {
    fetchData ({ page, filter, sort }) {
      const tablePage = pagination.createPage(
        this.templates,
        this.tableState,
        ['name', 'description'],
        this.tablePageSize,
        { page, filter, sort }
      );
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    requestTemplates () {
      templateApi.getTemplates(this)
        .then((response) => {
          this.templates = response;
          this.$refs.templateTable.refresh();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    createTemplate () {
      this.$router.push({
        name: 'EditTemplate',
        params: { mode: 'create' }
      });
    },
    editTemplate (row) {
      this.$router.push({
        name: 'EditTemplate',
        query: { templateId: row.id },
        params: { template: row }
      });
    },
    removeTemplate (row) {
      this.templateToDelete = row;
      this.showConfirmationDeleteModal = true;
    },
    onDeleteConfirm () {
      templateApi.deleteTemplate(this, this.templateToDelete.id)
        .then(() => {
          this.showConfirmationDeleteModal = false;
          this.templateToDelete = null;
          this.requestTemplates();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onDeleteCancel () {
      this.showConfirmationDeleteModal = false;
      this.templateToDelete = null;
    }
  }
};
</script>

<style lang="scss">
@import "src/stylesheets/variables";

#header {
  display: inline-block;
  width: 100%;
  line-height: 1rem;
}
.header-title {
  float: left;
}
.header-add-button {
  float: right;
}
.header-add-button-icon {
  font-size: 3rem;
  color: $secondary;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/nutritionalPlan/NutritionalPlanTemplateList.vue